<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="listCentroCostos?.length > 0">
            <CorporateDataTable
                :items="listCentroCostos"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editCentroCostos(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createCentroCostos()">
                        {{ labels.addCentroCosto }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modCrearCentroCostos="showCentroCostos" @creado="actualizarTabla" @cierraModal="closeModal"/>
        <Editar :modEditarCentroCostos="showEditCentroCostos" :infoCentroCostos="dataCentroCosto" @actualizado="actualizarTabla" @eliminado="actualizarTabla" @cierraModal="closeModal"/>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos' 
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import Crear from './Crear.vue'; 
import Editar from './Editar.vue'; 
export default {
    name : 'CentroCostos',
    components : {
        Crear,
        Editar,
        CorporateDataTable
    },
    data : () => ({
        listCentroCostos : [],
        showCentroCostos : false,
        showEditCentroCostos : false,
        dataCentroCosto : [],
        fields: [
            { key: 'codigo', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'centro_costo', label: 'Centro de costo', sortable: false },
        ],
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Centros de costos',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    centro_costo : 'Centro de Costo',
                    noRow : 'No hay registros.',
                    addCentroCosto : "Añadir centro de costo",
                    filterCodigo : 'Filtrar código...', 
                    filterDescripcion : 'Filtrar descripción...', 
                    filterCentroCosto : 'Filtrar centro de costo...', 
                }
            }else{
                return {
                    title : 'Cost center',
                    codigo : 'Code',
                    descripcion : 'Description',
                    centro_costo : 'Centro de Costo',
                    noRow : 'There are no records.',
                    addCentroCosto : "Add cost center",
                    filterCodigo : 'Filter code...', 
                    filterDescripcion : 'Filter description...', 
                    filterCentroCosto : 'Filter cost center...', 
                }
            }
        },
        allFields(){
            return [
                { key: 'codigo', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'centro_costo', label: this.labels.centro_costo, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'codigo', type: 'text', placeholder: this.labels.filterCodigo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion },
                { key: 'centro_costo', type: 'text', placeholder: this.labels.filterCentroCosto },
            ]
        },
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        closeModal(val){
           this.showCentroCostos = val 
           this.showEditCentroCostos = val 
        },
        createCentroCostos(){
            this.showCentroCostos = true 
        },
        editCentroCostos(id){
            // console.log(id); 
            CentroCostos.getCentroCostosById(id) 
            .then((res) => { 
                // console.log(res.data); 
                this.dataCentroCosto = res.data.centroCosto 
                this.showEditCentroCostos = true 
            })
            .catch((err) => console.log(err)) 
        },
        actualizarTabla(){
            CentroCostos.getAllCentroCostos() 
            .then((res) => { 
                this.listCentroCostos = res.data.listCentroCostos 
            })
            .catch((err) => (console.log(err)))
        }
    },
    mounted(){
        CentroCostos.getAllCentroCostos() 
        .then((res) => { 
            this.listCentroCostos = res.data.listCentroCostos 
        })
        .catch((err) => (console.log(err))) 
    }
}
</script>

<style>

</style>
